

import ThemeApp from './ThemeSwichLandingPage';

function App() {
  return (
    <div className="App">
      <ThemeApp/>
    </div>
  );
}

export default App;
